module.exports = __webpack_public_path__ + "static/media/investor.21f32141.svg";